module.exports = __webpack_public_path__ + "bd6996f9c0921f5e744aba81d3dadd84.png";